import React from 'react'
import { DashboardLayout } from '../layouts'
import { AddFormControl, AgentsDropdown, CreateFieldWrapper } from '../containers'
import { useState } from 'react'
import FormContainer from '../../application/formbuilder/FormContainer';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import services from '../../ioc/services';
import ROUTES from '../../application/utils/Routes';

function AddForm() {

    const { state } = useLocation();

    const [formFields, setFormFields] = useState([]);
    const [assignedAgents, setAssignedAgents] = useState([]);
    const [formObject, setFormObject] = useState({
        title: "Form " + Math.floor(Math.random() * 3000000),
        isPublic: false
    });

    const [isFormUpdate, setIsFormUpdate] = useState(false);

    const navigate = useNavigate();

    const saveForm = () => {

        if (formObject.title == null || formObject.title == undefined || formObject.title.trim() == '') {
            services.alert.toast.error("Please enter form title");
            return;
        }

        if (formObject.fields.length == 0) {
            services.alert.toast.error("Please add at least one field to the form");
            return;
        }

        // Validate fields with dropdown options (radio/checkbox)
        const typesWithKeyValue = ['radio', 'checkbox'];
        const fieldsWithOptions = formFields.filter(f => f.name && f.prompt && typesWithKeyValue.includes(f.key));
        
        for (const field of fieldsWithOptions) {
            if (!field.options || field.options.length === 0) {
                services.alert.toast.error(`Field "${field.prompt || field.name || 'Untitled'}" (${field.key}) must have at least one option`);
                return;
            }
            
            // Check if all options have valid key and value
            const hasEmptyOptions = field.options.some(opt => 
                !opt.key || opt.key.trim() === '' || !opt.value || opt.value.trim() === ''
            );
            
            if (hasEmptyOptions) {
                services.alert.toast.error(`Field "${field.prompt || field.name || 'Untitled'}" (${field.key}) has incomplete options. Please fill in all option labels and values`);
                return;
            }
        }

        if (isFormUpdate) {

            services.api.form.updateForm(formObject.id, formObject)
                .then(res => {

                    services.alert.toast.success("Form Updated Successfully");
                    navigate(ROUTES.FORMDETAIL.replace(":id", formObject.id));
                })
        }
        else {

            services.api.form.addForm(formObject)
                .then(res => {
                    services.alert.toast.success("Form Created Successfully");
                    navigate(ROUTES.FORMS);
                })
        }

    }

    const updateFormTitle = title => {
        setFormObject({ ...formObject, title })
    }

    const updateFormDescription = description => {
        setFormObject({ ...formObject, description })
    }

    const updateFormVisibility = isPublic => {
        setFormObject({ ...formObject, isPublic })
    }


    useEffect(() => {
        if (state) {
            const { form } = state;

            if (form) {
                setIsFormUpdate(true);
                setFormFields(form.fields);
                setAssignedAgents([...form.agents]);
                setFormObject(form)
            }
        }
    }, [])

    useEffect(() => {
        setFormObject(olf => {
            return {
                ...olf,
                fields: formFields.filter(f => f.name && f.prompt),
                agents: assignedAgents
            }
        })

    }, [formFields, assignedAgents])


    const formPropsClasses = "flex-1 outline-none border-b border-b-gray-200 focus:border-b-2 focus:border-b-green-500 ";

    return (
        <DashboardLayout>
            <div className="flex flex-col gap-5 max-h-[80vh]">
                <div className="">
                    <AddFormControl setFormFields={setFormFields} saveFormFunction={saveForm} isUpdate={isFormUpdate} />
                </div>
                <div className=' flex flex-col flex-1 gap-5 overflow-y-auto'>
                    <div className='flex justify-center text-sm gap-5 mx-10'>
                        <h1 className="font-semibold">FORM TITLE:</h1>
                        <input type='text' value={formObject.title} className={formPropsClasses} onChange={(e) => updateFormTitle(e.target.value)} />
                    </div>
                    <div className='flex justify-center text-sm gap-5 mx-10'>
                        <h1 className="font-semibold">FORM DESCRPTION:</h1>
                        <input type='text' value={formObject.description} className={formPropsClasses} onChange={(e) => updateFormDescription(e.target.value)} />
                    </div>

                    <div className='mx-10 text-sm flex gap-10 items-center' >
                        <div className=' relative'>
                            <label
                                className=" uppercase font-semibold inline-block pl-[0.15rem] mr-5 hover:cursor-pointer"
                                htmlFor="flexSwitchCheckDefault"
                            >Make Form Public</label>
                            <input
                                className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                checked={formObject.isPublic}
                                onChange={(e) => updateFormVisibility(e.target.checked)}
                            />

                        </div>

                        <div className='flex gap-3 items-center'>
                            <label className=' font-semibold '>Assign to Agents: </label>
                            <AgentsDropdown valueUpdater={setAssignedAgents} defaultValue={assignedAgents} />
                        </div>
                    </div>

                    <div className=' grid grid-cols-[1fr,auto,1fr] gap-4 mt-3'>
                        <div className=' '>
                            <h2 className=' text-center font-semibold text-lg'>Edit Form Inputs</h2>
                            {formFields.map((formField, index) =>
                                <CreateFieldWrapper
                                    field={formField}
                                    position={index + 1}
                                    setFields={setFormFields}
                                    allowPartialEdit={isFormUpdate} />
                            )}
                        </div>

                        <div className='border-r-2 border-r-slate-200'></div>
                        <div>
                            <h2 className=' text-center font-semibold text-lg'>Preview</h2>
                            <FormContainer fields={formFields} />

                        </div>

                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default AddForm